if (!customElements.get('mm-cart-drawer')) {
  customElements.define(
    'mm-cart-drawer',
    class MMCartDrawer extends HTMLElement {
      connectedCallback() {
        this.bind();
        document.addEventListener('mm:cart:updated', (e) => this.render(e.detail));
        document.addEventListener('mm:cart:open', () => this.open());
      }

      bind() {
        this.querySelectorAll('[data-mm-drawer-close]').forEach((el) =>
          el.addEventListener('click', (ev) => {
            ev.preventDefault();
            this.close();
          })
        );
        this.querySelectorAll('[data-mm-qty]').forEach((btn) =>
          btn.addEventListener('click', () => this.change(btn.dataset.mmQty, btn.dataset.mmTo))
        );
      }

      get panel() {
        return this.querySelector('[data-mm-drawer-panel]');
      }

      open(trigger) {
        this.opener = trigger || document.activeElement;
        this.classList.add('is-open');
        document.documentElement.classList.add('mm-drawer-open');
        this.onKey = (e) => {
          if (e.key === 'Escape') this.close();
          if (e.key === 'Tab') this.trap(e);
        };
        document.addEventListener('keydown', this.onKey);
        requestAnimationFrame(() => this.panel && this.panel.focus());
      }

      close() {
        this.classList.remove('is-open');
        document.documentElement.classList.remove('mm-drawer-open');
        if (this.onKey) document.removeEventListener('keydown', this.onKey);
        if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
      }

      trap(e) {
        const focusable = this.panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      busy(on) {
        this.classList.toggle('is-busy', on);
        this.querySelectorAll('[data-mm-qty]').forEach((b) => {
          b.disabled = on;
        });
      }

      error(message) {
        const body = this.querySelector('[data-mm-drawer-body]');
        if (!body) return;
        let box = body.querySelector('.mm-drawer__error');
        if (!box) {
          box = document.createElement('p');
          box.className = 'mm-drawer__error';
          box.setAttribute('role', 'alert');
          body.prepend(box);
        }
        box.textContent = message;
      }

      get sectionList() {
        return window.MMCart ? window.MMCart.sectionList() : 'mm-cart-drawer,cart-icon-bubble';
      }

      sync(sections) {
        this.render(sections);
        if (window.MMCart) window.MMCart.syncPage(sections);
      }

      change(line, quantity) {
        this.busy(true);
        fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: Number(line),
            quantity: Number(quantity),
            sections: this.sectionList,
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => (r.ok ? r.json() : Promise.reject(r)))
          .then((data) => (data.sections ? this.sync(data.sections) : this.refresh()))
          .catch(() => {
            this.busy(false);
            this.error('Mise à jour impossible. Réessayez dans un instant.');
          });
      }

      refresh() {
        return fetch(`${window.Shopify.routes.root}?sections=${this.sectionList}`)
          .then((r) => (r.ok ? r.json() : Promise.reject(r)))
          .then((data) => this.sync(data))
          .catch(() => {
            this.busy(false);
            this.error('Mise à jour impossible. Réessayez dans un instant.');
          });
      }

      render(sections) {
        if (!sections) return;
        const html = sections['mm-cart-drawer'];
        if (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('mm-cart-drawer');
          if (fresh) {
            const wasOpen = this.classList.contains('is-open');
            this.innerHTML = fresh.innerHTML;
            if (fresh.hasAttribute('data-empty')) this.setAttribute('data-empty', '');
            else this.removeAttribute('data-empty');
            this.bind();
            if (wasOpen) requestAnimationFrame(() => this.panel && this.panel.focus());
          }
        }
        const bubble = sections['cart-icon-bubble'];
        if (bubble) {
          const target = document.getElementById('cart-icon-bubble');
          const doc = new DOMParser().parseFromString(bubble, 'text/html');
          const fresh = doc.getElementById('cart-icon-bubble') || doc.querySelector('.shopify-section');
          if (target && fresh) target.innerHTML = fresh.innerHTML;
        }
        this.busy(false);
      }
    }
  );
}
